import { useContext, useEffect } from "react";
import { NotificationsContext } from "@contexts/Notifications/context";
import { getNotifications } from "./api/notifications";

export const useNotificationsBootstrap = () => {
  const { setNotifications } = useContext(NotificationsContext);

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const notifications = await getNotifications();
        setNotifications(notifications);
      } catch (error) {
        console.error("[Notifications] Erro ao carregar notificações", error);
      }
    };

    void loadNotifications();
  }, [setNotifications]);
};
